(() => {
  const root = document.getElementById('pp-shoe-size-config');
  if (!root) return;
  const t = JSON.parse(root.textContent);
  let unit = 'US';
  let availableOnly = !new URLSearchParams(location.search).getAll('filter.v.availability').includes('0');
  const applyStock = () => {
    document.querySelectorAll('facet-filters-form form').forEach(form => {
      const values = [...form.querySelectorAll('input[name="filter.v.availability"]')];
      if (values.length) values.forEach(i => { i.checked = availableOnly && i.value === '1'; });
      else if (availableOnly) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'filter.v.availability'; input.value = '1';
        input.dataset.ppStock = 'true'; form.append(input);
      }
      if (!availableOnly) form.querySelectorAll('[data-pp-stock]').forEach(i => i.remove());
    });
  };
  const num = s => Number(s.replace(',', '.').split(' ')[0]) + (s.includes('1/3') ? 1/3 : s.includes('2/3') ? 2/3 : 0);
  const parse = value => {
    const raw = value.trim().replace(/,/g, '.');
    const eu = raw.match(/(?:EU(?:R)?\s*)(\d+(?:\.\d+)?(?:\s+[12]\/3)?)/i);
    const us = raw.match(/US\s*(\d+(?:\.\d+)?)/i);
    const dual = raw.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)M\s*\/\s*(\d+(?:\.\d+)?)W$/i);
    if (dual) return {EU: dual[1], US: dual[2] + ' M / ' + dual[3] + ' W'};
    if (eu || us) return {EU: eu?.[1], US: us?.[1]};
    if (/^\d+(?:\.\d+)?$/.test(raw) && Number(raw) >= 30 && Number(raw) <= 50) return {EU: raw};
    return {};
  };
  const el = (tag, cls, text) => {
    const node = document.createElement(tag);
    node.className = cls;
    if (text) node.textContent = text;
    return node;
  };
  const build = details => {
    const inputs = [...details.querySelectorAll('input[type="checkbox"][name="filter.v.option.size"]')];
    if (!inputs.length) return;
    const title = details.querySelector('summary span');
    if (title && title.textContent !== t.title) title.textContent = t.title;
    if (details.querySelector('.pp-size-ui')) return;
    const list = inputs[0].closest('ul');
    if (!list) return;
    const panel = list.parentElement;
    details.classList.add('pp-size-filter');
    list.classList.add('pp-size-native');
    const summary = details.querySelector('summary span');
    if (summary) summary.textContent = t.title;
    const ui = el('div', 'pp-size-ui');
    const subtitle = el('p', 'pp-size-caption', t.caption);
    const tabs = el('div', 'pp-size-tabs');
    tabs.setAttribute('role', 'group');
    tabs.setAttribute('aria-label', t.system);
    const grid = el('div', 'pp-size-grid');
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', t.title);
    const other = el('details', 'pp-size-other');
    const otherTitle = el('summary', '', t.other);
    const otherGrid = el('div', 'pp-size-grid pp-size-grid-other');
    other.append(otherTitle, otherGrid);
    const note = el('p', 'pp-size-note', t.note);
    const done = el('button', 'pp-size-done', t.done);
    done.type = 'button';
    done.addEventListener('click', () => {
      const drawer = details.closest('.mobile-facets__wrapper');
      if (drawer) drawer.querySelector('summary')?.click();
      else details.open = false;
    });
    const stock = el('label', 'pp-size-stock');
    const stockText = el('span', '', t.available);
    const stockCheck = el('input', 'pp-size-stock-check');
    stockCheck.type = 'checkbox';
    stockCheck.checked = availableOnly;
    stock.append(stockText, stockCheck);
    stockCheck.addEventListener('input', event => {
      event.stopPropagation();
      availableOnly = stockCheck.checked;
      document.querySelectorAll('.pp-size-stock-check').forEach(i => { i.checked = availableOnly; });
      applyStock();
      inputs[0].dispatchEvent(new Event('input', {bubbles:true}));
    });
    ui.append(subtitle, tabs, grid, other, note, stock, done);
    panel.insertBefore(ui, list);
    const groups = {US: new Map(), EU: new Map(), other: new Map()};
    const add = (map, key, input) => { if (!map.has(key)) map.set(key, []); map.get(key).push(input); };
    inputs.forEach(input => {
      const data = parse(input.value);
      for (const key of ['US', 'EU']) if (data[key]) add(groups[key], data[key], input);
      if (!data.US && !data.EU) add(groups.other, input.value, input);
    });
    const buttons = [];
    const renderButtons = (map, into) => {
      into.replaceChildren();
      [...map].sort((a,b) => num(a[0])-num(b[0])).forEach(([label, members]) => {
        const b = el('button', 'pp-size-button', label.replace(' 1/3', '⅓').replace(' 2/3', '⅔'));
        b.type = 'button';
        b.disabled = members.every(i => i.disabled);
        b.title = [...new Set(members.map(i => i.value))].join('\n');
        const sync = () => b.setAttribute('aria-pressed', String(members.some(i => i.checked)));
        sync();
        buttons.push(sync);
        b.addEventListener('click', () => {
          const checked = !members.some(i => i.checked);
          members.forEach(i => { if (!i.disabled || !checked) i.checked = checked; });
          document.querySelectorAll('.pp-size-filter').forEach(d => {
            if (d === details) return;
            for (const i of d.querySelectorAll('input[type="checkbox"]')) {
              const source = inputs.find(s => s.name === i.name && s.value === i.value);
              if (source) i.checked = source.checked;
            }
          });
          buttons.forEach(fn => fn());
          applyStock();
          members[0].dispatchEvent(new Event('input', {bubbles:true}));
        });
        into.append(b);
      });
    };
    const paint = () => {
      buttons.length = 0;
      renderButtons(groups[unit], grid);
      renderButtons(groups.other, otherGrid);
      other.hidden = !groups.other.size;
      tabs.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.textContent === unit)));
      const gender = [...document.querySelectorAll('input[name*="gender"]:checked')].map(i => i.value);
      const unique = [...new Set(gender)].filter(g => g !== 'Unisex');
      subtitle.textContent = unit === 'EU' ? t.eu : unique.length === 1 ? 'US ' + unique[0] : t.caption;
    };
    ['US','EU'].forEach(key => {
      const b = el('button', '', key);
      b.type = 'button';
      b.addEventListener('click', () => {
        unit = key;
        document.querySelectorAll('.pp-size-ui').forEach(n => n.dispatchEvent(new Event('pp-unit')));
      });
      tabs.append(b);
    });
    ui.addEventListener('pp-unit', paint);
    details.addEventListener('input', () => buttons.forEach(fn => fn()));
    paint();
  };
  const scan = () => {
    document.querySelectorAll('details.js-filter').forEach(build);
    const filters = new URLSearchParams(location.search).getAll('filter.v.availability');
    if (filters.length) {
      availableOnly = filters.includes('1') && !filters.includes('0');
      document.querySelectorAll('.pp-size-stock-check').forEach(i => { i.checked = availableOnly; });
    }
  };
  let defaultStockRequestQueued = false;
  let lastAvailabilitySearch = location.search;
  const ensureDefaultStock = () => {
    const selected = new URLSearchParams(location.search).getAll('filter.v.availability');
    if (selected.includes('0') || selected.includes('1')) return;
    availableOnly = true;
    applyStock();
    if (defaultStockRequestQueued) return;
    const trigger = [...document.querySelectorAll('facet-filters-form input[name="filter.v.availability"]')].find(input => input.value === '1')
      || document.querySelector('facet-filters-form input[name^="filter."]');
    if (!trigger) return;
    defaultStockRequestQueued = true;
    setTimeout(() => {
      if (new URLSearchParams(location.search).getAll('filter.v.availability').includes('0')) {
        defaultStockRequestQueued = false;
        return;
      }
      trigger.dispatchEvent(new Event('input', {bubbles:true}));
    }, 0);
  };
  scan();
  ensureDefaultStock();
  const initial = new URLSearchParams(location.search);
  if (initial.has('filter.v.option.size') && !initial.has('filter.v.availability')) {
    setTimeout(() => {
      const input = document.querySelector('.pp-size-filter input[name="filter.v.option.size"]:checked');
      input?.dispatchEvent(new Event('input', {bubbles:true}));
    }, 0);
  }
  let queued = false;
  const observer = new MutationObserver(records => {
    if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('input[name="filter.v.option.size"], .js-filter, .facets__summary') || n.querySelector('input[name="filter.v.option.size"]'))))) return;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      if (location.search !== lastAvailabilitySearch) {
        lastAvailabilitySearch = location.search;
        defaultStockRequestQueued = false;
      }
      scan();
      ensureDefaultStock();
    });
  });
  observer.observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
})();
